import { Button } from "@component/button";
import RejectionIcon from "@component/rejection-icon";
import { CompanyPreferences } from "@type/company";
import { cn } from "@util/tailwind";

interface Props {
    companyPreferences?: CompanyPreferences | undefined
}

function ApplicationDraft(props: Props) {
    return (
        <div className={cn("max-w-2xl mx-auto h-[calc(100vh-112px)] flex flex-col justify-center items-center", {
            "h-[calc(100vh-220px)]": props.companyPreferences,
            "h-[calc(100vh-112px)] sm:h-[calc(100vh-220px)]": !props.companyPreferences,
        })}>
            <div
                className="bg-white dark:bg-gray-900 rounded-3xl p-4 mx-4 sm:mx-0 sm:p-8 border border-gray-100 dark:border-gray-800 text-center"
                style={{ border: "0px solid transparent", boxShadow: '0px 0px 0px #000000, 0px 4px 30px -4px rgba(0, 0, 0, 0.3)' }}
            >
                <RejectionIcon className={`mx-auto mb-2 sm:mb-6 !text-yellow-600 bg-yellow-100`} />

                <h1 className="text-xl sm:text-2xl font-bold mb-2">
                    Save Application as Draft
                </h1>
                <p className="text-gray-600 mb-6 max-w-lg mx-auto whitespace-pre-line">
                    Your AI Interview isn’t finished yet. Recruiters will only review your application once all steps are completed.
                </p>

                <div
                    className={`mx-auto p-4 rounded-lg border mb-5 bg-yellow-50 border-yellow-500`}
                >
                    <h2 className={`text-lg font-medium mb-3 text-yellow-700 text-left`}>
                        What to do next:
                    </h2>
                    <ul className={`text-left space-y-3 text-sm m-0 text-yellow-700`}
                    >
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium flex-shrink-0`}
                            >
                                1
                            </span>
                            Your progress is saved, you can return anytime.
                        </li>
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium flex-shrink-0`}
                            >
                                2
                            </span>
                            Go to My Jobs → Draft to continue where you left off.
                        </li>
                        <li className="flex items-start gap-3 m-0">
                            <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium flex-shrink-0`}
                            >
                                3
                            </span>
                            Finish your AI Interview to submit your application.
                        </li>
                    </ul>
                </div>

                <Button
                    variant="default"
                    className="bg-blue-600"
                    onClick={() => {
                        window.location.href = "/my-jobs";
                    }}>
                    Continue to Dashboard
                </Button>
            </div>
        </div>
    );
}

export default ApplicationDraft